import React from 'react';

const ServiceItem = ({ service, selectedServices, onSelectService }) => {
  const categoryChecked = selectedServices.filter((c) => c.id === service.id).length;

  return (
    <div data-bem="ServiceItem" className="service">
      <div>
        <input
          type="checkbox"
          className="checkbox-switch"
          id={`${service.name}${service.id ? service.id : 'category'}`}
          onChange={() => {
            onSelectService(service);
          }}
          checked={categoryChecked > 0}
        />

        <label htmlFor={`${service.name}${service.id ? service.id : 'category'}`} className="checkbox-bullet">
          {service.name}
        </label>
      </div>

      {service.services?.length > 0 && categoryChecked > 0 && (
        <ul>
          {service.services.map((subService) => (
            <li key={subService.id} className="dropdown-item subItem">
              <label className="clickable-label">
                <span className="li-service">{subService.name}</span>

                <div className="checkbox-box-custom-wrap dd-chk">
                  <input
                    type="checkbox"
                    className="checkbox-box-custom"
                    id={`clints-check-${subService.id ? subService.id : '1'}`}
                    checked={selectedServices.filter((c) => c.id === subService.id).length > 0}
                    onChange={() => {
                      onSelectService(subService);
                    }}
                  />

                  <label className="checkbox-box-label" htmlFor={`clints-check-${subService.id ? subService.id : '1'}`}>
                    <div className="checkbox-box-custom-icon">
                      <span className="ic-sml-18px ic_check_white_18" />
                    </div>
                  </label>
                </div>
              </label>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default ServiceItem;
